import styled from 'styled-components';
import media from 'styled-media-query';

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;

  background-color: rgba(0, 0, 0, 0.47);
`;

export const Layer = styled.div`
  width: 100%;
  height: 100vh;

  ${media.greaterThan('small')`
    height: auto;

    display: flex;
    align-items: flex-start;
    justify-content: center;

    padding: 4rem 0;
  `}
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  height: 100%;

  ${media.greaterThan('small')`
    width: 45rem;
    height: auto;

    border-radius: 1.5rem;
  `}

  background-color: rgba(244, 243, 240, 1);
`;
